import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FaRegCheckSquare } from 'react-icons/fa';
import { MdOutlineFileUpload } from "react-icons/md";

const FileInput = ({ name, label, onChange, value, error }) => {
    const { t } = useTranslation();
    const fileInputRef = useRef();
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        setSelectedFile(value || null);
    }, [value]);

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
        onChange(event);
    };

    const hasFile = !!selectedFile;

    return (
        <div className="mb-6">
            <div className="flex items-center space-x-4">
                <button
                    type="button"
                    onClick={handleButtonClick}
                    className={`w-40 h-28 rounded-xl flex flex-col items-center justify-center text-sm border-2 transition-all
                        ${error
                            ? 'border-red-500 text-red-500'
                            : hasFile
                                ? 'border-primary text-primary'
                                : 'border-dashed border-gray-300 text-gray-400'
                        }`}
                >
                    <div className="text-2xl mb-2">
                        {hasFile ? <FaRegCheckSquare /> : <MdOutlineFileUpload />}
                    </div>
                    <span className="text-center">
                        {hasFile ? 'Modifier le fichier' : 'Ajouter le fichier'}
                    </span>
                </button>

                <input
                    type="file"
                    name={name}
                    label={label}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept="application/pdf,.pdf"
                    className="hidden"
                />
            </div>

            {error && <p className="text-red-500 text-xs mt-1">{t(error)}</p>}
        </div>
    );
};

export default FileInput;